var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sitecling__container" }, [
    _vm.siteclingisvisible
      ? _c(
          "div",
          {
            key: _vm.id,
            staticClass: "sitecling__panel",
            class: `${_vm.siteclingtheme}`,
            style: `display: siteclingisvisible ? 'flex' : 'none'`,
            attrs: {
              "aria-label": "Alert",
              id: _vm.id + "-panel",
              role: "region",
            },
          },
          [
            _c("div", { staticClass: "sitecling__message-container" }, [
              _c("div", { staticClass: "sitecling__content" }, [
                this.siteclingmessage
                  ? _c("div", {
                      staticClass: "wysiwyg",
                      domProps: { innerHTML: _vm._s(this.siteclingmessage) },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.ctalabel && _vm.ctainputedurl
                ? _c("div", { staticClass: "sitecling__cta" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn",
                        class: `${_vm.ctatheme}`,
                        on: {
                          click: function ($event) {
                            return _vm.goToUrl()
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "btn__content" }, [
                          _c("span", { staticClass: "btn__text" }, [
                            _vm._v(_vm._s(_vm.ctalabel)),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.alertclosingbutton === true
              ? _c(
                  "div",
                  {
                    staticClass: "sitecling__close-bt",
                    attrs: {
                      id: _vm.id + "-button",
                      "aria-controls": _vm.id + "-panel",
                    },
                    on: { click: _vm.setalertclosecookievalue },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 16 15.983",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M1.772 0A1.774 1.774 0 00.537 3.046L5.491 8 .537 12.955a1.774 1.774 0 102.509 2.509L8 10.509l4.954 4.954a1.774 1.774 0 102.509-2.509L10.508 8l4.954-4.954A1.774 1.774 0 1012.954.538L7.999 5.492 3.045.537A1.774 1.774 0 001.772 0z",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }